import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import Button from '@/components/UI/Button';
import { HookForm } from '@/components/UI/HookForm/Form';
import { HookInput } from '@/components/UI/HookForm/Form/Input';
import { HookFormProvider } from '@/components/UI/HookForm/Provider';
import Modal from '@/components/UI/Modal';
import { postDefaultCategories } from '../../../api/category';
import { ReactQueryKey } from '../../../constants/ReactQueryKeys';
import { notifyUser } from '../../../store/Toast';
import { sanitizeResponseError } from '../../../utils';

const GetStarted = () => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  const onSubmit = (formData: any) => {
    if (formData.email === 'protected@stp.tech' && formData.password === 'kS>#^LVFWWHY1azWw9dG') {
      setIsAuthenticated(true);
    }
  };

  const loadDefaultCategories = useMutation(() => postDefaultCategories(), {
    onSuccess: () => {
      queryClient.invalidateQueries([ReactQueryKey.GET_CATEGORIES]);
      dispatch(
        notifyUser({
          showToast: true,
          toastMessage: 'Default Categories loaded successfully',
          toastType: 'success',
        })
      );
    },
    onError: (error: any) => {
      const resError = sanitizeResponseError(error);
      dispatch(
        notifyUser({
          showToast: true,
          toastMessage: resError,
          toastType: 'failed',
        })
      );
    },
  });

  return (
    <>
      {isAuthenticated && (
        <div className='container mx-auto py-4'>
          <h2 className='mt-0'>Get Started</h2>
          <dl className='flex gap-4 border rounded'>
            <div className='flex justify-between items-center w-full px-4 py-2'>
              <dt className='flex flex-col'>
                <span className='font-semibold'>Default Categories</span>
                <span className='text-xs text-neutralColor-normal'>
                  Default categories defined by Sage Technology Partners team.
                  <span className='text-tertiaryColor-normal font-semibold'> Warning!!! </span>
                  It will replace the existing categories on the account.
                </span>
              </dt>
              <dd>
                <Button
                  label={`${loadDefaultCategories.isLoading ? '...' : 'Load'}`}
                  btnStyle='primary'
                  disabled={loadDefaultCategories.isLoading}
                  onClick={loadDefaultCategories.mutate}
                />
              </dd>
            </div>
          </dl>
        </div>
      )}
      {!isAuthenticated && (
        <Modal>
          <HookFormProvider>
            <HookForm onSubmit={onSubmit} className='space-y-4'>
              <h3>Protected Resource Authentication</h3>
              <HookInput id='email' name='email' label='Email' type='text' />
              <HookInput id='password' name='password' label='Password' type='password' />

              <Button label='Submit' btnStyle='primary' type='submit' />
            </HookForm>
          </HookFormProvider>
        </Modal>
      )}
    </>
  );
};

export default GetStarted;
